import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import { type EntityRef } from "@client/types";
import GridView, { type GridViewProps } from "@common/controls/GridView/component";
import { type GridViewToolbar } from "@common/controls/GridView/types";
import React from "react";

import { getEntityRef } from "@client/content/lib/helper";
import "./style.less";

export type Props<T extends {}, D extends {}, ModalProps = void> = GridViewProps<T, D, ModalProps> &
  EntityRef & {
    fieldStyle: React.CSSProperties;
    visibleColumns: string[] | null;
  };
export default <T extends {}, D extends {}, ModalProps = void>({
  id,
  source,
  visibleColumns,
  ...props
}: Props<T, D, ModalProps>) => {
  const columns = React.useMemo(() => {
    if (!visibleColumns) return props.columns;

    return props.columns.filter((x) => visibleColumns.includes(x.key));
  }, [props.columns, visibleColumns]);

  const toolbar = React.useMemo(
    (): GridViewToolbar<T> =>
      props.toolbar
        ? { ...props.toolbar, isAlwaysVisible: true }
        : { showAdd: true, showSearch: true, isAlwaysVisible: true },
    [props.toolbar]
  );

  return (
    <FormStyleProvider {...getEntityRef({ id, source })}>
      <GridView {...props} columns={columns} noDataMode="grid" toolbar={toolbar} />
    </FormStyleProvider>
  );
};
